import { ChartCategoryFilter, DashboardWidgetRequestPayload } from '../../components/UI/NewDashboad/stores/observationDashboardStore'
import request from '../axiosInterceptor'

const api = {
  getObservationDashboard(query?: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-flow/observations-dashboard/observations-list${query || ''}`,
      method: 'get',
    })
  },
  getSiteWalkthroughDashboard() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/sitewalkthrough-list`,
      method: 'get',
    })
  },
  getIncidentDashboard(query: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-flow/incidents-dashboard/incidents-list${query}`,
      method: 'get',
    })
  },
  getInspectionDashboard(query: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-flow/inspections-dashboard/inspection-list${query}`,
      method: 'get',
    })
  },
  getTrainingDashboard(query: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-flow/training-dashboard/training-list${query}`,
      method: 'get',
    })
  },
  getNaiHubDashboardQuery(platform: any, copilotIndex: any, pagination: any, fromDate?: string, toDate?: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-hub/${copilotIndex}/dashboard-recent-query?platform=${platform}&page_number=${pagination?.pageIndex}&page_size=${pagination?.pageSize}${fromDate && toDate ? `&from_date=${fromDate}&to_date=${toDate}` : ''}`,
      method: 'get',
    })
  },
  getNaiHubDashboardCharts(platform: any, copilotIndex: any, fromDate?: string, toDate?: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-hub/${copilotIndex}/dashboard-metrics?platform=${platform}${fromDate && toDate ? `&from_date=${fromDate}&to_date=${toDate}` : ''}`,
      method: 'get',
    })
  },
  getDashboardSubsidiaries() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/list-of-subsidiaries`,
      method: 'get',
    })
  },
  getDashboardProjects() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/list-of-projects-by-org`,
      method: 'get',
    })
  },
  postDashboardSafetyCount(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/safety-count`,
      method: 'post',
      data: data,
    })
  },
  postDashboardIncidentCategory(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/incident-category-c-view`,
      method: 'post',
      data: data,
    })
  },
  postDashboardStatisticOverview(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/statistic-capture-c-view`,
      method: 'post',
      data: data,
    })
  },
  postDashboardIncidentDaysOverview(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/incident-not-reported-days`,
      method: 'post',
      data: data,
    })
  },
  getNaiHubVideoAnalytics(platform: any, copilotIndex: any, pagination: any, fromDate?: string, toDate?: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-hub/${copilotIndex}/video-analytics?platform=${platform}&page_number=${pagination?.pageIndex}&page_size=${pagination?.pageSize}${fromDate && toDate ? `&from_date=${fromDate}&to_date=${toDate}` : ''}`,
      method: 'get',
    })
  },
  getObservationForLinkedProjects(query?: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/observations-dashboard/observations-list${query || ''}`,
      method: 'get',
    })
  },
  getIncidentForLinkedProjects(query: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/incidents-dashboard/incidents-list${query}`,
      method: 'get',
    })
  },
  getTrainingForLinkedProjects(query: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/training-dashboard/training-list${query}`,
      method: 'get',
    })
  },
  postStatiticsCaptureReports(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/statistic-capture-report`,
      method: 'post',
      data: data,
    })
  },
  // New Dashboard APIs
  getNewDashboardProjectList() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/project-list`,
      method: 'get',
    })
  },
  getNewDashboardProjectListLinked() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/project-list`,
      method: 'get',
    })
  },
  getNewDashboardSummary() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/new/summary`,
      method: 'get',
    })
  },
  getDashboardRootCauseV2(payload: DashboardWidgetRequestPayload) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/observation/charts`,
      method: 'post',
      data: payload,
    })
  },
  getDashboardEntityData(payload: DashboardWidgetRequestPayload) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/observation/charts`,
      method: 'post',
      data: payload,
    })
  },
  getNewDashboardSeverity() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/new/severity`,
      method: 'get',
    })
  },
  getNewDashboardObservationAge() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/new/observation-age`,
      method: 'get',
    })
  },
  getNewDashboardHazardType() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/new/hazard-type`,
      method: 'get',
    })
  },
  getNewDashboardLocations() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/new/locations`,
      method: 'get',
    })
  },
  // Get observation counts per project
  postObservationCountsPerProject(data: {
    filters: {
      date_range: {
        from_date: string | null;
        to_date: string | null;
      };
      subsidiaries: Array<{
        id: string;
        project_ids: string[];
      }>;
      platform: string;
      categories?: ChartCategoryFilter[];
    };
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/observation/counts/per-project`,
      method: 'post',
      data: data,
    })
  },
  // Get observation summary counts
  postObservationCounts(data: {
    filters: {
      date_range: {
        from_date: string | null;
        to_date: string | null;
      };
      subsidiaries: Array<{
        id: string;
        project_ids: string[];
      }>;
      platform: string;
      categories?: ChartCategoryFilter[];
    };
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/observation/counts`,
      method: 'post',
      data: data,
    })
  },
  postDashboardObservationExport(payload: {
    project_id: string
    subsidiary_id: string
    format: string
    filters: { key: string; value: string }[]
    date_range?: {
      from_date: string
      to_date: string
    }
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/observation/export`,
      method: 'post',
      data: payload,
    })
  },
  postDashboardSiteWalkthroughExport(payload: {
    project_id: string
    subsidiary_id: string
    format: string
    filters: { key: string; value: string }[]
    date_range?: { from_date: string; to_date: string }
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/site-walkthrough/export`,
      method: 'post',
      data: payload,
    })
  },

  // Incident dashboard – charts (same payload shape as observation)
  getDashboardIncidentCharts(payload: DashboardWidgetRequestPayload) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/incident/charts`,
      method: 'post',
      data: payload,
    })
  },
  // Incident dashboard – entity/location data
  getDashboardIncidentEntityData(payload: DashboardWidgetRequestPayload) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/incident/charts`,
      method: 'post',
      data: payload,
    })
  },
  // Training dashboard – charts (same payload shape as observation)
  getDashboardTrainingCharts(payload: DashboardWidgetRequestPayload) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/training/charts`,
      method: 'post',
      data: payload,
    })
  },
  // Training dashboard – entity/location data
  getDashboardTrainingEntityData(payload: DashboardWidgetRequestPayload) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/training/charts`,
      method: 'post',
      data: payload,
    })
  },
  
  // Incident counts per project
  postIncidentCountsPerProject(data: {
    filters: {
      date_range: {
        from_date: string | null;
        to_date: string | null;
      };
      subsidiaries: Array<{
        id: string;
        project_ids: string[];
      }>;
      platform: string;
      categories?: ChartCategoryFilter[];
      body_part_filter?: { body_part_id: number };
    };
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/incident/counts/per-project`,
      method: 'post',
      data: data,
    })
  },

    // Training counts per project
    postTrainingCountsPerProject(data: {
      filters: {
        date_range: {
          from_date: string | null;
          to_date: string | null;
        };
        subsidiaries: Array<{
          id: string;
          project_ids: string[];
        }>;
        platform: string;
        categories?: ChartCategoryFilter[];
      };
    }) {
      return request({
        url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/training/counts/per-project`,
        method: 'post',
        data: data,
      })
    },

  // Incident dashboard – injury breakdown (body parts)
  postIncidentBodyParts(data: {
    filters: {
      date_range: {
        from_date: string | null;
        to_date: string | null;
      };
      subsidiaries: Array<{
        id: string;
        project_ids: string[];
      }>;
      time_grain?: string;
      platform?: string;
      categories?: ChartCategoryFilter[];
      /** Intentionally omitted when filtering by figure: breakdown stays full list for the table. */
      body_part_filter?: { body_part_id: number };
    };
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/incident/body_parts`,
      method: 'post',
      data: data,
    });
  },

  // Incident summary counts
  postIncidentCounts(data: {
    filters: {
      date_range: {
        from_date: string | null;
        to_date: string | null;
      };
      subsidiaries: Array<{
        id: string;
        project_ids: string[];
      }>;
      platform: string;
      categories?: ChartCategoryFilter[];
      body_part_filter?: { body_part_id: number };
    };
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/incident/counts`,
      method: 'post',
      data: data,
    })
  },

   // Training summary counts
   postTrainingCounts(data: {
    filters: {
      date_range: {
        from_date: string | null;
        to_date: string | null;
      };
      subsidiaries: Array<{
        id: string;
        project_ids: string[];
      }>;
      platform: string;
      categories?: ChartCategoryFilter[];
    };
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/training/counts`,
      method: 'post',
      data: data,
    })
  },

  // Org Dashboard – counts (safety_events / environment_people)
  postOrgDashboardCounts(data: {
    filters: {
      date_range: { from_date: string | null; to_date: string | null };
      subsidiaries: Array<{ id: string; project_ids: string[] }>;
      subsidiary_master_id?: string;
      time_grain: string;
      platform: string;
      source: string;
      widget_id?: string;
      categories?: ChartCategoryFilter[];
      body_part_filter?: { body_part_id: number };
    };
    force_refresh: boolean;
    view_type: string;
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/counts`,
      method: 'post',
      data: data,
    })
  },

  // Org Dashboard – charts (observation / incident / training workflows)
  postOrgDashboardCharts(data: {
    filters: {
      date_range: { from_date: string | null; to_date: string | null };
      subsidiaries: Array<{ id: string; project_ids: string[] }>;
      subsidiary_master_id?: string;
      time_grain: string;
      platform: string;
      source: string;
      widget_id: string;
      categories?: ChartCategoryFilter[];
    };
    workflow: string;
    view_type?: string;
    force_refresh: boolean;
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/org-dashboard/charts`,
      method: 'post',
      data: data,
    })
  },
  postDashboardTrainingExport(payload: {
    project_id: string
    subsidiary_id: string
    format: string
    filters: { key: string; value: string }[]
    date_range?: { from_date: string; to_date: string }
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/training/export`,
      method: 'post',
      data: payload,
    })
  },
}

export default api
